module.exports = __webpack_public_path__ + "img/near-point-convergence.d6745f9b.png";